import React, { useState, useEffect , useRef } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Toolbar } from 'primereact/toolbar'; 
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { InputNumber } from 'primereact/inputnumber';
import { Toast } from 'primereact/toast';
import { Card } from 'primereact/card';   
import { Fieldset } from 'primereact/fieldset';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { InputTextarea } from 'primereact/inputtextarea';
import { getClientes } from '../api/clientesService';//getClientes
import { getSeries } from '../api/seriesService';//
import { getMonedas,getFormasPago, getMediosPago, getTipoCambioMoneda} from '../api/monedaFormaPagoService';
import { getProductos } from '../api/productoService'; // crea esto si no lo tienes
import {addFactura }from '../api/facturaService'; 
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable"; // IMPORTANTE

import {getEmpresa} from '../api/empresaService';

function MainFacturas({Auth}) {
    
  let emptyClientes = {
    id: null,
    nombre: null,
    descripcion: '',
    unidad: '',
    tipo: '',
    peso: ''       
  };

  let emptySeries={
    _id:null,
    noSerie:null,
    alias:'',
    serie:'',
    ultimoFolio:null,
    estado:null,
    tipo:'',
    diseno:''
  };
     
  let emptyFactura={        
    _id: null,
    datosEmisor:[{
      razonSocial:"",
      ruc:"",
      regimenFiscal:""
    }],

    datosReceptor:[{
      razonSocial:"",
      ruc:"",
      regimenFiscal:"",
      pais:"",
      cp:"",
    }], 

    detalleFactura: [],

    
    serie: "",
    folio: null,
    tipoFactura:"",
    formaPago: "",
    medioPago:"",
    diasApagar:null,
    moneda:"",
    tipoCambio:"",
    subTotal: 0.0,
    totalImpuestos: 0.0,
    totalConImpuestos:0.0,
    totalPagar: 0.0,
    saldoPendiente:0.0,
    status:"",
    vigente:1
    
  };

  const [factura, setFactura] = useState(emptyFactura);
  const [clientes, setClientes] = useState([]);
  const [cliente, setCliente] = useState(emptyClientes); 
  const [series, setSeries] = useState([]);      
  const [serie, setSerie] = useState(emptySeries);

  // ID único (fallback si crypto.randomUUID no existe)
const uid = () => {
  try { return crypto.randomUUID(); } catch (e) { return `${Date.now()}_${Math.random().toString(16).slice(2)}`; }
};

  const [productos, setProductos] = useState([]); 
  const [productosFactura, setProductosFactura] = useState([]);
  const [productoSeleccionado, setProductoSeleccionado] = useState(null);
  const [productoActual, setProductoActual] = useState(null);
  const [productoDialog, setProductoDialog] = useState(false);
  const [editIndex, setEditIndex] = useState(null);
  const [date, setDate] = useState(new Date);

  const toast = useRef(null);
  const dt = useRef(null);
  
    
  const [descripcion, setDescripcion] = useState('');
  const [precioUnitario, setPrecioUnitario] = useState('');
  const [cantidad, setCantidad] = useState(1);
  const [importe, setImporte] = useState(0);
         
  const [monedaSeleccionado, setMonedaSeleccionado] = useState(null); // producto del dropdown
  const [pagoSeleccionado, setPagosSeleccionado] = useState(null); // producto del dropdown
  const [dialogVisible, setDialogVisible] = useState(false);

const [monedas, setMonedas] = useState([]);
const [moneda, setMoneda] = useState(null);
const [formaPagos, setFormasPagos] = useState([]);
const [formaPago, setFormasPago] = useState(null); 
const [medioPagos, setMediosPagos] = useState([]);   
const [medioPago, setMediosPago] = useState(null);
const [tipoCambio, setTipoCambio] = useState(1.0); // Nuevo estado para el tipo de cambio


const [empresa, setEmpresa] = useState([]);
const [pdfPreview, setPdfPreview] = useState(null);
const [showPreview, setShowPreview] = useState(false);
const [pdfDoc, setPdfDoc] = useState(null); // estado para el jsPDF
const [diasCredito, setDiasCredito]=useState('');


useEffect(() => {
  const fetchEmpresa = async () => {
    const data = await getEmpresa();
   
    setEmpresa(data[0]);
  };
  fetchEmpresa();
}, []);
  // Cargar datos iniciales
useEffect(() =>{
  const fetchData = async () => 
    {
      const data = await getClientes();  
      const activas = data.filter(e => e.activo === true); // o e.estatus === "Activo"
      setClientes(activas); 
    };
   
  fetchData();
}, []);
   
const cargarSeries = async () => {
  const data = await getSeries();
  const activas = data.filter(e => e.estado === true);
  setSeries(activas);
};

useEffect(() => {
   cargarSeries();
}, []);

useEffect(() => {
  const fetchData = async () => setProductos( await getProductos());
  fetchData();
}, []);

// Cargar monedas al inicio
useEffect(() => {
    const fetchMonedas = async () =>setMonedas(await getMonedas()) ;
    fetchMonedas();
}, []);
useEffect(() => {
    if (monedas.length > 0 && empresa?.moneda) {
        const monedaInicial = monedas.find(
            (m) => m.codigo === empresa.moneda
        );
        if (monedaInicial) {
            setMoneda(monedaInicial);
        }
    }
}, [monedas, empresa]);
// Cargar formas de pago al inicio
useEffect(() => {
    const fetchFormaPago = async () =>setFormasPagos(await getFormasPago()) ;
    fetchFormaPago();
}, []);

useEffect(() => {
    const fetchMedioPago = async () =>setMediosPagos(await getMediosPago()) ;
    fetchMedioPago();
}, []);
          
useEffect(() => {
  const precio = parseFloat(precioUnitario);
  const cant = parseFloat(cantidad);
  if (!isNaN(precio) && !isNaN(cant)) {setImporte(precio * cant);} 
  else { setImporte(0); }
  }, [precioUnitario, cantidad]);
  
useEffect(() => {
  // 1️⃣ Calcular subtotal
  const nuevoSubtotal = productosFactura.reduce((acc, item) => acc + (Number(item.importe) || 0), 0);

  const nuevoTotalImpuestos = productosFactura.reduce((acc, item) => {
  const subtotalItem = item.importe || 0;
  const impuestosItem = item.impuestos?.reduce(
      (sum, imp) => sum + (subtotalItem * imp.porcentaje) / 100,
      0
    ) || 0;
    return acc + impuestosItem;
  }, 0);
  
  // 3️⃣ Calcular total con impuestos
  const nuevoTotalConImpuestos = nuevoSubtotal + nuevoTotalImpuestos;

  setFactura(prev => ({
    ...prev,
    detalleFactura: productosFactura, // sincronizamos
    subTotal: nuevoSubtotal,
    totalImpuestos: nuevoTotalImpuestos,
    totalConImpuestos: nuevoTotalConImpuestos,
    // iva: nuevoIva,
    totalPagar: nuevoTotalConImpuestos
  }));
}, [productosFactura]);

// Función para abrir diálogo de producto (nuevo o editar)
const abrirDialogo = (producto = null, index = null) => {
  setProductoActual(  producto || {
      productoId: "",
      nombre: "",
      descripcion: "",
      cantidad: 0,
      precioUnitario: 0.0,
      importe: 0,
      unidad: "", });
  setEditIndex(index);
  setProductoDialog(true);
};

const agregarProductoAFactura = () => {
  if (!productoActual || !productoActual.nombre)  
  {
    toast.current.show({
    severity: "warn",
    summary: "Atención",
    detail: "Debes seleccionar un producto válido",});
    return;
  }
   // Validar que el importe sea mayor a 0
  if ((productoActual.importe || 0) <= 0) {
    toast.current.show({ severity: 'warn', summary: 'Advertencia', detail: 'El importe debe ser mayor a 0', life: 3000 });
    return;
  }


 const prod = {
    ...productoActual,
    cantidad: Number(productoActual.cantidad) || 0,
    precioUnitario: Number(productoActual.precioUnitario) || 0,
  };
  prod.importe = prod.cantidad * prod.precioUnitario;

  if (editIndex !== null) {
    // editar renglón existente
    setProductosFactura(prev => {
      const copia = [...prev];
      // conservar idUnico si existía
      copia[editIndex] = { ...prod, idUnico: copia[editIndex].idUnico || uid() };
      return copia;
    });
  } else {
    // agregar nuevo renglón con id único
    setProductosFactura(prev => [...prev, { ...prod, idUnico: uid() }]);
  }
  //recalcularTotales(nuevosDetalles);
  setProductoDialog(false);
  setProductoActual(null);
  setProductoSeleccionado(null);
  setEditIndex(null);
  }; 
const subtotal = productoActual?.importe || 0;
const totalImpuestos = productoActual?.impuestos?.reduce(
  (sum, imp) => sum + (subtotal * imp.porcentaje) / 100,
  0
);
const totalConImpuestos = subtotal + totalImpuestos;
 // Recalcular subtotal, IVA y total
const recalcularTotales = (productos) => {
  const nuevoSubtotal = productos.reduce(
      (acc, item) => acc + (item.importe || 0), 0);
      
    const nuevoIva = nuevoSubtotal * 0.16;
    const nuevoTotal = nuevoSubtotal + nuevoIva;

    setFactura((prev) => ({
      ...prev,
      detalleFactura: productos,
      subTotal: nuevoSubtotal,
      totalImpuestos:totalImpuestos,
      totalConImpuestos:totalConImpuestos,
      // iva: nuevoIva,
      totalPagar: nuevoTotal,
    }));
  };

const editarProducto = (rowData, index) => {
  // rowData proviene de la fila; index es útil pero aseguramos que exista
  const idx = typeof index === 'number' ? index : productosFactura.findIndex(p => p.idUnico === rowData.idUnico);
  if (idx === -1) return;
  // preparamos objeto editable (clon)
  setProductoActual({ ...productosFactura[idx] });
  // setProductoSeleccionado(null); // opcional: limpiar selección del dropdown
  setEditIndex(idx);
  setProductoDialog(true);
  
};
  // Eliminar producto
const eliminarProducto = (id) => {
  confirmDialog({
    message: `¿Seguro que deseas eliminar el producto de la lista?`,
    header: 'Confirmar eliminación',
    icon: 'pi pi-exclamation-triangle',
    acceptLabel: 'Sí, eliminar',
    rejectLabel: 'Cancelar',
    acceptClassName: 'p-button-danger',
    rejectClassName: 'p-button-secondary',
    accept: () => {
  setProductosFactura(prev => prev.filter(p => p.idUnico !== id));
  toast.current?.show({
        severity: 'success',
        summary: 'Eliminado',
        detail: 'Producto eliminado correctamente',
        life: 3000,
      });
    },
    reject: () => {
      toast.current?.show({
        severity: 'info',
        summary: 'Cancelado',
        detail: 'No se eliminó el registro',
        life: 2000,
      });
    },
  });
};
 const handleMonedaChange = async (e) => {
  try {
    const selected = e.value;
    setMoneda(selected);             // mantiene la moneda seleccionada en UI
    setMonedaSeleccionado(selected?.codigo || selected); // si usas ese estado

    const monedaObjetivo = empresa?.moneda || 'MXN'; 
    const monedaBase = selected?.codigo || selected; // ejemplo: 'USD', 'NIC', 'MXN'

    // --- SOLO SI ES DÓLAR (USD) ---
    if (monedaBase === "USD") {
      // 1️⃣ Verificar si ya existe tipo de cambio cargado manualmente
      if (empresa.tipoCambioDolares > 0) {

        const tc = empresa?.tipoCambioDolares ?? null;
        setTipoCambio(tc);
        setFactura(prev => ({ ...prev, tipoCambio:tc }));
        return; // Finalizamos aquí, NO consultamos backend
      }
// 2️⃣ Si NO hay tipo de cambio → consultar backend
     // console.log("No hay tipo de cambio previo, consultando backend…");
      const data = await getTipoCambioMoneda({ monedaBase, monedaObjetivo });
      const tc = data?.data?.tipoCambio ?? 1;
      setTipoCambio(tc);
      setFactura(prev => ({ ...prev, tipoCambio: tc }));
      return;
    }

     // --- PARA MONEDAS QUE NO SON USD ---
   // console.log("Moneda seleccionada no es USD, flujo normal");

    const data = await getTipoCambioMoneda({ monedaBase, monedaObjetivo });
    const tc = data?.data?.tipoCambio ?? 1;

    setTipoCambio(tc);
    setFactura(prev => ({ ...prev, tipoCambio: tc }));
  } catch (err) {
    toast.current?.show({ severity: 'error', summary: 'Error', detail: 'No se pudo obtener tipo de cambio' });
    console.error(err);
  }
};

const guardarFactura = async (esPreview = false) => {

  if (!cliente || !serie || factura.detalleFactura.length === 0) {
    toast.current.show({
      severity: "warn",
      summary: "Atención",
      detail: "Debes seleccionar cliente, serie y agregar productos", });
    return;
  } 
   // 2️⃣ Validación de FORMA DE PAGO
  if (!formaPago || !formaPago.nombre) {
    toast.current.show({
      severity: "warn",
      summary: "Atención",
      detail: "Debes seleccionar una FORMA DE PAGO",
    });
    return;
  }

// 2.1️⃣ Si la forma de pago es CREDITO → pedir días
  if (formaPago?.nombre === "CREDITO") {
    if (!diasCredito || diasCredito <= 0) {
      toast.current.show({
        severity: "warn",
        summary: "Atención",
        detail: "Debes ingresar los días de crédito (mayor a 0)",
      });
      return;
    }
  }

  // 3️⃣ Validación de MÉTODO DE PAGO
  if (!medioPago || !medioPago.nombre) {
    toast.current.show({
      severity: "warn",
      summary: "Atención",
      detail: "Debes seleccionar un MEDIO DE PAGO",
    });
    return;
  }
 
try {
  const facturaAGuardar = { ...emptyFactura,
    datosEmisor: [{ razonSocial: "", ruc: "", regimenFiscal: "" }],
    datosReceptor: [
        {
          razonSocial: cliente.razonSocial,
          ruc: cliente.ruc,
          regimenFiscal: cliente.regimenFiscal,
          pais: cliente.pais,
          cp: cliente.cp,
        },],
    detalleFactura: factura.detalleFactura,
    fechaEmision: new Date(date),
    serie: serie.serie,
    folio: Number(serie?.ultimoFolio || 0) + 1,
    tipoFactura: serie.tipo,
    formaPago: formaPago?.nombre || "",
    medioPago:medioPago?.nombre || "",
    diasApagar:diasCredito || 0,
    moneda: monedaSeleccionado || "",
    tipoCambio:tipoCambio || 1.00,
    subTotal: factura.subTotal,
    // : factura.iva,
    totalImpuestos:factura.totalImpuestos,
    totalConImpuestos:factura.totalConImpuestos,
    totalPagar: factura.totalPagar,
    saldoPendiente:factura.totalPagar,
    status: "ADEUDO",
    vigente: 1 ,
    create_at: new Date(),
  };
  console.log(facturaAGuardar);
  if(esPreview)
  {
     // 2️⃣ Generar PDF después de guardar
    const doc = new jsPDF();

    // Logo
  
    if (empresa?.logo) {
      
       const logoformato = empresa.logo.split(",")[0];
       console.log(logoformato);
      const logoBase64 = empresa.logo.split(",")[1]; // quitar el "data:image/png;base64,"
      
      doc.addImage(logoBase64, "PNG", 10, 10, 60, 30);
     
      //doc.addImage(empresa.logo, "png", 14, 10, 40, 20); 
      // 📍 Parámetros: (imagenBase64, formato, x, y, ancho, alto)
    }

    // Encabezado
    doc.setFontSize(10);
    doc.text("Lugar Expedicion", 150, 15);
    doc.text(`${empresa.direccion.municipio} ${empresa.direccion.pais}`, 160, 20);
    
    doc.setFontSize(10);
    doc.text(`Folio:`, 150, 30);
    doc.text(`${facturaAGuardar.folio}`, 160, 30);

    doc.text(`Fecha`, 150, 40);
    doc.text(` ${facturaAGuardar.fechaEmision.toISOString().split('T')[0]}`, 160, 45);
    
    doc.text(`Orden de compra: `, 150, 50);
    doc.text(` `, 160, 55);

    doc.text(`Tipo de cambio: `, 150, 60);
    doc.text(`${facturaAGuardar.tipoCambio} `, 160, 65);
    

    // Datos del cliente
    doc.text("Cliente", 10, 50);

    doc.text(`Nombre: `, 10, 55);
    doc.text(`${facturaAGuardar.datosReceptor[0].razonSocial}`, 30, 55);

    doc.text(`RUC: `, 10, 60);
    doc.text(`${facturaAGuardar.datosReceptor[0].ruc}`, 30, 60);

    doc.text(`Direccion: `, 10, 65);
    doc.text(`${cliente.domicilio}`, 30, 65);

    // Tabla de productos
    autoTable(doc, {
      startY: 70,
      head: [["Cantidad","Descripcion",  "Precio", "Total"]],
      body: facturaAGuardar.detalleFactura.map((p) => [
        p.cantidad,
        p.descripcion,      
        p.precioUnitario,
        p.importe,        
      ]),
    });

    // Totales
    let finalY =  240;//doc.lastAutoTable.finalY ||
    doc.text(`Subtotal: `, 140, finalY + 10);
     doc.text(`${facturaAGuardar.subTotal.toFixed(2)}`, 160, finalY + 10);

    doc.text(`Impuestos: `, 140, finalY + 16);
    doc.text(`${facturaAGuardar.totalImpuestos.toFixed(2)}`, 160, finalY + 16);

    doc.text(`Total: `, 140, finalY + 22);
    doc.text(`${facturaAGuardar.totalConImpuestos.toFixed(2)}`, 160, finalY + 22);


  setPdfDoc(doc); // guardamos el objeto doc en el estado
  setPdfPreview(doc.output("datauristring")); 
  setShowPreview(true);
return;

  }
  console.log(facturaAGuardar);
 
  await addFactura(facturaAGuardar);

    await cargarSeries();

  ////
    toast.current.show({
    severity: "success",
    summary: "Éxito",
    detail: "Factura guardada",
  });

  setFactura(emptyFactura);
  setCliente(emptyClientes);
  setSerie(emptySeries);
  setProductosFactura([]);
  setDate(new Date());
  setMonedaSeleccionado(null);
  setPagosSeleccionado(null);
  } catch (error) {
    console.error('Error al guardar factura:', error);
    toast.current.show({ severity: 'error', summary: 'Error', detail: 'No se pudo guardar' });
  }
};

const exportCSV = () => {
        dt.current.exportCSV();
    };

const leftToolbarTemplate = () => {
        return (
            <div className="flex flex-wrap gap-2">
                <Button label="Agregar Producto / Servicio" icon="pi pi-plus" severity="success" onClick={() => abrirDialogo()} />
                <Button label="Exportar" icon="pi pi-upload" className="p-button-help" onClick={exportCSV}/>
              </div>
        );
    };


return (
        <>
<Toast ref={toast} />
<ConfirmDialog />
  <section className="mission-section" id="facturas">        
    <div class="layout-content-inner">
      <div>
        <nav class="layout-breadcrumb">
          <ol>
            <li><a href="/"><i class="pi pi-home"></i></a></li>
            <li class="layout-breadcrumb-chevron"> / </li>
            <li>Facturas</li>
          </ol>
        </nav>
      </div>
        
      <Card title="Facturación"></Card>
      <h5></h5>
      <div className="card">
        <div className="grid p-fluid input-demo">
          <div className="col-12 md:col-8">
            <Fieldset legend="Datos del Cliente"><h5>Cliente:</h5>              
              <Dropdown value={cliente} onChange={(e) => setCliente(e.value)} options={clientes}   
                placeholder="Selecciona un cliente"  className="w-full md:w-40rem" optionLabel="razonSocial"
                itemTemplate={(option) => `${option.ruc} - ${option.razonSocial}`}
                valueTemplate={(option, props) => option ? `${option.ruc} - ${option.razonSocial}` : props.placeholder}
                emptyMessage="No hay clientes "/>
              
              <div class='row'>
                <h5>Empresa:</h5> {cliente.razonSocial}
                <h5>RUC:</h5>{cliente.ruc}
                <h5>Codigo Postal:</h5> {cliente.codigoPostal}
                <h5>Regimen fiscal:</h5> {cliente.regimen}
              </div> 
            </Fieldset>
          </div>

          <div className="col-12 md:col-4">
            <Fieldset legend="General"><h5>Serie:</h5>
              <Dropdown value={serie} onChange={(e) => setSerie(e.value)} options={series} 
                placeholder="Selecciona una opción" className="w-full md:w-300rem" optionLabel="alias" 
                itemTemplate={(option) => `${option.serie} - ${option.alias}`}
                valueTemplate={(option, props) => option ? `${option.serie} - ${option.alias}` : props.placeholder}
                emptyMessage="No hay series "/>
                       
              <div className="flex-auto">
                <label htmlFor="buttondisplay" className="font-bold block mb-2">
                <h5>Fecha:</h5></label>
                <Calendar value={date} onChange={(e) => setDate(e.value)}  dateFormat="dd/mm/yy" showIcon  />
              </div>
              
              <div class="formgroup-inline">
                <h5>Tipo:</h5><InputText disabled placeholder={serie.tipo} />
                <h5>Folio:</h5><InputText disabled placeholder={Number(serie?.ultimoFolio || 0) + 1} />
              </div>
              <div>
                <h5>Moneda:</h5>
                <Dropdown id="idMoneda"  value={moneda} 
                  onChange={handleMonedaChange} 
                  options={monedas}
                  placeholder="Seleccione" className="w-full md:w-300rem" optionLabel="name"  
                  itemTemplate={(option) => `${option.codigo} - ${option.moneda}`}
                  valueTemplate={(option, props) => option ? `${option.codigo} - ${option.moneda}` : props.placeholder}/>
              </div>
              <div>
                <h5>Tipo de cambio:</h5><InputText value={tipoCambio} placeholder="" />
              </div>                        
            </Fieldset>
          </div>
        </div>

        <Fieldset legend="Producto / Servicio"><Toolbar className="mb-4" right={leftToolbarTemplate} ></Toolbar>     
        <DataTable value={productosFactura}  responsiveLayout="scroll" ref={dt}  dataKey="idUnico" stripedRows selectionMode="single"  emptyMessage=" ">
          <Column field="descripcion" header="Descripcion" />
          <Column field="precioUnitario" header="Precio Unitario" />
          <Column field="cantidad" header="Cantidad" />
          <Column field="importe" header="Importe" />
          <Column header="Acciones" body={(rowData, options) => (<>
            <Button icon="pi pi-pencil" className="p-button-text p-button-sm p-mr-2"
              onClick={() => editarProducto(rowData, options.rowIndex)}/>
            
            <Button icon="pi pi-trash" className="p-button-text p-button-sm p-button-danger"
              onClick={() => eliminarProducto(rowData.idUnico)}/></> )}
          />
        </DataTable>
        </Fieldset>

        <div className="formgrid grid">
          <div className="field col">
            <Fieldset legend="Forma de Pago">
              <Dropdown id="idFormatoPago" value={formaPago} 
              onChange={(e) => setFormasPago(e.value)} options={formaPagos}
              placeholder="Seleccione " className="w-full md:w-300rem" optionLabel="name" 
              itemTemplate={(option) => `${option.numero} - ${option.nombre}`} 
              valueTemplate={(option, props) => option ? `${option.numero} - ${option.nombre}` : props.placeholder}  />
             <label>
 {/* {formaPago?.nombre?.toLowerCase()} */}

             </label>
            
              {formaPago?.nombre === 'CREDITO' && (
            <div className="mt-3">
              <label htmlFor="diasCredito" className="block font-bold mb-2">Días a pagar:</label>
              <InputNumber
                id="diasCredito"
                value={diasCredito}
                onValueChange={(e) => setDiasCredito(e.value)}
                min={1}
                max={120}
                placeholder="Ej. 30"
                showButtons
              />
            </div>
            
          ) }


            </Fieldset>

          </div>
          <div className="field col">
            <Fieldset legend="Medios de pago">
              <Dropdown id="idMediosPago" value={medioPago} 
              onChange={(e) => setMediosPago(e.value)} options={medioPagos}
              placeholder="Seleccione " className="w-full md:w-300rem" optionLabel="name" 
              itemTemplate={(option) => `${option.numero} - ${option.nombre}`} 
              valueTemplate={(option, props) => option ? `${option.numero} - ${option.nombre}` : props.placeholder}  />
            </Fieldset>
            
          </div>
          <div className="field col">
            <Fieldset legend="Montos">
              <div class='formgrid grid'>   
                  <div class="field  col-7 "><p class="text-right font-bold ">Subtotal: </p> </div> 
                  <div class="field  col-5">
                     <div class="field  col-5  text-right text-teal-900 font-bold ">{moneda?.signo || '$'}
                      {/* {Number(factura.subTotal||0).toFixed(2).toLocaleString('en-US')}                       */}
                      {Number(factura.subTotal || 0).toLocaleString('en-US', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </div> 
                  </div>
              </div>
              <div class='formgrid grid'>  
                    <div class="field  col-7 "><p class="text-right font-bold">Impuestos: </p> </div>  
                     <div class="field  col-5">                   
                     <div class="field  col-5  text-right text-teal-900 font-bold ">{moneda?.signo || '$'}                     
                      {Number(factura.totalImpuestos || 0).toLocaleString('en-US', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </div> 
                       </div>                      
              </div>
              <div class='formgrid grid'>                 
                   <div class="field  col-7 "><p class="text-right font-bold">Total a Pagar: </p> </div>  
                  <div class="field col-5">
                     <div class="field  col-5  text-right text-teal-900 font-bold ">{moneda?.signo || '$'}
                     {Number(factura.totalPagar || 0).toLocaleString('en-US', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </div> 
                  </div>
              </div>
              
            </Fieldset>
            
             
          </div>            
        </div>
        <div className="formgrid grid">
          <div className="field col"></div>
          <div className="field col"></div>
          <div className="field col"></div>
          <div className="field col"></div>
          <div className="field col">
            <Button label="Vista Preliminar" icon="pi pi-eye" className="p-button-help mt-5" onClick={() => guardarFactura(true)} />
          </div>
          <div className="field col">
            
            <Button label="Guardar Factura" icon="pi pi-save" className="p-button-success mt-5" onClick={() => guardarFactura(false)} />
          </div>
        </div>
        
      </div>
    
      <Dialog  header={editIndex !== null ? "Editar concepto" : "Agregar concepto"} visible={productoDialog}  onHide={() => {setProductoDialog(false);setProductoSeleccionado(null);}}
        
          style={{
          width: "90vw", // ancho flexible en pantallas pequeñas
          maxWidth: "900px", // ancho máximo en escritorio
        }}
        contentStyle={{
          overflowY: "auto", // permite scroll si el contenido crece
          maxHeight: "85vh", // evita que crezca más allá de la pantalla
        }}
        breakpoints={{
          '960px': '95vw', // tablets y móviles grandes
          '640px': '100vw' // móviles pequeños
        }}
        >
      <div class="grid">
        <div class= "col-12 md:col-6">
          <div class= "card p-fluid">
            <h5> Concepto:</h5>         
            <Dropdown   value={productoSeleccionado }  options={productos}  onChange={(e) => {    const prod = e.value;
              setProductoSeleccionado(prod); // reference al option
              setProductoActual({
                productoId: prod._id || prod.productoId || "",
                nombre: prod.nombre || "",
                unidad: prod.unidad || "",
                precioUnitario:parseFloat( prod.precioUnitario )|| 0.0,
                cantidad: 0,
                importe: (prod.precioUnitario || 0) * 0,
                descripcion: prod.descripcion|| "" ,// dejamos vacía para que el usuario escriba
                impuestos:prod.impuestos||[]
              });
            }}
              placeholder="Selecciona una opción" className="w-full md:w-300rem" optionLabel="nombre"  disabled={editIndex !== null}  emptyMessage="" />
            <h5>Descripcion:</h5>
            <InputTextarea id="description" value={productoActual?.descripcion || ""} onChange={(e) => setProductoActual({ ...productoActual, descripcion: e.target.value })} rows={4} cols={30} className="w-full md:w-300rem" />
          </div>
        </div>

        <div className="col-12 md:col-6">
          <div className="card p-fluid"> 
            <div class="grid nested-grid">
                <div class="col-12">
                    <div class="formgrid grid">
                        <div class="field grid col-6 font-bold"><label>Precio Unitario :</label></div>
                        <div class="field grid col-6 font-bold">
                            <InputNumber  value={productoActual?.precioUnitario || 0 } onValueChange={(e) => setProductoActual({ ...productoActual, precioUnitario: parseFloat(e.target.value) || 0,
                            importe:
                              (parseFloat(e.target.value) || 0) * productoActual.cantidad,})}   mode="decimal"  locale="en-US"  minFractionDigits={2}/> 
                        </div>
                        <div class="field grid col-6 font-bold"><label>Cantidad :</label></div>
                        <div class="field grid col-6 font-bold">
                           <InputNumber value={productoActual?.cantidad || 0} onValueChange={(e) => setProductoActual({...productoActual, cantidad: parseFloat(e.target.value) || 0,
                          importe:
                            (productoActual.precioUnitario *   (parseFloat(e.target.value) )|| 0), })} mode="decimal"  locale="en-US"   />
                        </div>
                         <div class="field grid col-6 font-bold"><label>Importe :</label></div>
                        <div class="field grid col-6 font-bold">
                           <InputNumber value={Number(productoActual?.importe || 0).toFixed(2)} disabled  mode="decimal"  locale="en-US"  minFractionDigits={2} />
                        </div>
                    </div>
                </div>
              </div>            
          </div>
        </div>
      </div>
      

        <div className="grid">
          <div class= "col-12 md:col-6">
            <div className="card p-fluid" title="Impuestos" >
        {/* <h5>Impuestos aplicados:</h5>   */}
          {productoActual?.impuestos && productoActual.impuestos.length > 0 ? (
          <div className="formgrid grid" >
            {/* Encabezados */}
            <div className="field col-12 md:col-4 font-bold"></div>
            <div className="field col-12 md:col-3 font-bold text-right">Impuesto</div>
            <div className="field col-12 md:col-2 font-bold text-center"></div>
            <div className="field col-12 md:col-3 font-bold text-right">Valor</div>
            {/* Filas dinámicas */}
            {productoActual?.impuestos.map((imp, index) => {
              // 💡 cálculo del valor de cada impuesto
              const valorImpuesto =
                ((productoActual?.importe || 0) * (imp?.porcentaje || 0)) / 100;

              return (
                 <React.Fragment key={index}>
                  <div className="field col-12 md:col-4"> </div>
                  <div className="field col-12 md:col-3 col-1 ">{imp.abreviatura}</div>
                  <div className="field col-12 md:col-2 col-1 ">{imp.porcentaje}%</div>
                  <div className="field col-12 md:col-3 col-2 text-right">$
                    {/* {valorImpuesto?.toFixed(2)} */}
                     {Number(valorImpuesto || 0).toLocaleString('en-US', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}

                  </div>
                </React.Fragment>
              );
            })}
            </div>
          ) : (
            <p className="ml-3 text-gray-500">Este producto no tiene impuestos asociados.</p>
          )}       
            </div>
          </div>

          <div className="col-12 md:col-6">
            <div className="card p-fluid" title="Subtotal" >
              <div class="formgrid grid">                
                <div class="field  col-7 "><p class="text-right font-bold">Subtotal: </p> </div> 
                <div class="field  col-5  text-right text-teal-900 font-bold ">$
                  {/* {Number(subtotal||0).toFixed(2)}  */}
                   {Number(subtotal || 0).toLocaleString('en-US', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                </div>
            </div>
            <div class="formgrid grid">                
                <div class="field  col-7 "><p class="text-right font-bold">Total Impuestos: </p> </div> 
                <div class="field  col-5  text-right text-teal-900 font-bold ">$
                  {/* {Number(totalImpuestos||0).toFixed(2)}  */}
                  {Number(totalImpuestos || 0).toLocaleString('en-US', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                </div>
            </div>
            <div class="formgrid grid">              
                <div class="field  col-7 "><p class="text-right font-bold">Total a Pagar: </p> </div> 
                <div class="field  col-5  text-right text-teal-900 font-bold ">$
                  {/* {Number(totalConImpuestos  ||0).toFixed(2)}  */}
                  {Number(totalConImpuestos || 0).toLocaleString('en-US', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}

                </div>
            </div>            
        </div>
        <div className=' col-12 text-right'>
        <Button label={editIndex !== null ? "Actualizar" : "Agregar"} icon={editIndex !== null ? "pi pi-pencil" : "pi pi-plus"} onClick={agregarProductoAFactura}  />
        </div>
         

        </div>
       </div>  
      </Dialog> 
      <Dialog  header="Vista previa Factura"
  visible={showPreview}
  onHide={() => setShowPreview(false)}
  style={{ width: "80vw", height: "80vh" }}
>
  {pdfPreview && (
    <iframe
      src={pdfPreview}
      title="PDF"
      width="100%"
      height="600px"
      style={{ border: "none" }}
    />
  )}
  <div style={{ marginTop: "10px", textAlign: "right" }}>
    <Button label="Cerrar" icon="pi pi-times" onClick={() => setShowPreview(false)} className="p-button-text" />
    <Button label="Descargar" icon="pi pi-download" onClick={() => pdfDoc?.save(`Factura_${factura.folio}.pdf`)} />
  </div>
</Dialog>          
    </div>
  </section>
</>
      
    );
}
export default MainFacturas;      